"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLocation = exports.LocationProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _router = require("@reach/router");

var _useLocation = _interopRequireDefault(require("./useLocation"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var LocationProvider = function LocationProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_router.Location, null, function (_ref2) {
    var location = _ref2.location,
        navigate = _ref2.navigate;
    var methods = (0, _useLocation.default)(location.search, navigate);
    return children(methods);
  });
};

exports.LocationProvider = LocationProvider;
LocationProvider.propTypes = {
  children: _propTypes.default.func.isRequired
};

var withLocation = function withLocation(Component) {
  return function (props) {
    return /*#__PURE__*/_react.default.createElement(_router.Location, null, function (_ref3) {
      var location = _ref3.location,
          navigate = _ref3.navigate;
      var methods = (0, _useLocation.default)(location.search, navigate);
      return /*#__PURE__*/_react.default.createElement(Component, _extends({
        navigate: navigate,
        location: location
      }, props, methods));
    });
  };
};

exports.withLocation = withLocation;